import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";

const languages = [
  { code: "es", name: "Español", flag: "🇨🇱" },
  { code: "en", name: "English", flag: "🇺🇸" },
];

export function LanguageSelector({ variant = "icon" }) {
  const { i18n } = useTranslation();

  const currentLang = languages.find((l) => l.code === i18n.language) || languages[0];

  const changeLanguage = (langCode) => {
    i18n.changeLanguage(langCode);
    localStorage.setItem("avx_rf_pro_language", langCode);
  };

  if (variant === "full") {
    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button 
            variant="ghost" 
            className="h-9 px-3 text-[#A1A1AA] hover:text-[#F4F4F5] hover:bg-white/5"
            data-testid="language-selector"
          >
            <span className="mr-2">{currentLang.flag}</span>
            <span className="text-sm">{currentLang.name}</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent 
          align="end" 
          className="bg-[#1A1A1A] border-white/10 min-w-[140px]"
        >
          {languages.map((lang) => (
            <DropdownMenuItem
              key={lang.code}
              onClick={() => changeLanguage(lang.code)}
              className={`cursor-pointer ${
                i18n.language === lang.code 
                  ? "text-[#34C759] bg-[#34C759]/10" 
                  : "text-[#A1A1AA] hover:text-[#F4F4F5]"
              }`}
              data-testid={`lang-${lang.code}`}
            >
              <span className="mr-2">{lang.flag}</span>
              {lang.name}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="ghost" 
          size="icon"
          className="h-9 w-9 text-[#A1A1AA] hover:text-[#F4F4F5] hover:bg-white/5"
          data-testid="language-selector"
        >
          <Globe className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent 
        align="end" 
        className="bg-[#1A1A1A] border-white/10 min-w-[140px]"
      >
        {languages.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => changeLanguage(lang.code)}
            className={`cursor-pointer ${
              i18n.language === lang.code 
                ? "text-[#34C759] bg-[#34C759]/10" 
                : "text-[#A1A1AA] hover:text-[#F4F4F5]"
            }`}
            data-testid={`lang-${lang.code}`}
          >
            <span className="mr-2">{lang.flag}</span>
            {lang.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
